import type { CustomerAlternativeContext } from '../../../../../services/customerRequests/types';
import React from "react";
import CostPriceDetailBody from "./CostPriceDetailBody";
import { CostTargets } from "../../../../../utils/costTargets";

interface CostPriceDetailModalProps {
    costPriceId: string;
    customerAlternative?: CustomerAlternativeContext;
    initialFocusProductKey?: string;
    onClose: () => void;
    costTargets?: CostTargets;
    // Restaurant-wide default ingredient waste %, the inherit fallback shown as
    // the per-ingredient placeholder and folded into the live cost.
    defaultWastePercentage?: number;
    // BYO = build-your-own. Caller handles lazy find-or-create of the CHOICE
    // analysis for `choiceName` (inheriting the parent dish's `parentCategoryId`)
    // and then re-opens the modal with that analysis's id. Optional — when
    // omitted, choice rows in the BYO hub are non-interactive (admin views).
    onEditChoice?: (choiceName: string, parentCategoryId: string | undefined) => void;
    // When set, the header swaps the close icon for a back arrow that triggers
    // this callback. Used when the modal is a child view (CHOICE opened from a
    // BYO dish): the user wants to return to the parent, not close the panel.
    onBack?: () => void;
    // BYO dish context: id of the parent BYO dish this CHOICE was opened from.
    // When set, quantity edits in the editor are stored as per-dish overrides
    // on that dish (`byoChoiceOverrides`) instead of editing the shared CHOICE.
    byoParentId?: string;
}

/**
 * The cost-price editor as a right-hand slide-over. All editor behavior lives in
 * CostPriceDetailBody; this wrapper just selects the slide-over chrome (fixed
 * backdrop + sliding panel + maximize width). Other hosts mount the body directly
 * with `host="embedded"`.
 */
const CostPriceDetailModal: React.FC<CostPriceDetailModalProps> = (props) => (
    <CostPriceDetailBody {...props} host="slideOver" />
);

export default CostPriceDetailModal;
